import regex from './regex';
import validationMessages from './validationMessages';

const appConstants = {
  RETURN_USER_ROUTE: '/mlde/login',
  FORGOT_PASSWORD_ROUTE: '/mlde/forgot-password',
  FORGOT_USERID_ROUTE: '/mlde/forgot-userId',
  WELCOME_USER_ROUTE: '/mlde',
  PASSWORD_RESET_SUCCESSFUL_ROUTE: '/mlde/resetsuccessful',
  CREATE_ACCOUNT_ROUTE: '/mlde/register',
  LOGIN_USER_ROUTE: 'https://mlde.uat.guardianlife.com/mldecst/',
  PAGE_NOT_FOUND_ROUTE: '/mlde/notfound',
  PASSWORD_CRITERIA: [
    {
      criteria: validationMessages.charRange,
      status: false,
      regex: regex.RANGE,
    },
    {
      criteria: validationMessages.upperLowerCase,
      status: false,
      regex: regex.CHAR_REGEX,
    },
    {
      criteria: validationMessages.aleastNumberAndSpecialChar,
      status: false,
      regex: regex.NUM_SPECIAL_REGEX,
    },
    {
      criteria: validationMessages.noCharMoreThanTwice,
      status: false,
      regex: regex.NO_MORE_TWICE,
    },
    {
      criteria: validationMessages.doesNotContains,
      status: false,
    },
    {
      criteria: validationMessages.doesNotContainFirstname,
      status: false,
    },
    {
      criteria: validationMessages.doesNotContainLastname,
      status: false,
    },
  ],
  WEEK_DAY: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  OPTION: '<<Option>>',
  PRIVACY_NOTICE: 'https://www.guardianlife.com/privacy-policy',
  GUARDIAN_LIFE: 'https://www.guardianlife.com/',
  GUARDIAN_OKTA_LOGIN: 'https://mlde.guardianlife.com/',
  SUPPORT_WEBSITE: 'Website support',
  SUPPORT_BENEFIT: 'Benefit support',
  SUPPORT_TEAM_TEXT: 'To speak with your support team, call',
  WEBSITE_CONTACT: '1-866-236-3220',
  BENEFIT_CONTACT: '1-410-490-1487',
  CONTACT_TIMING: ' (8am-4:30pm EST).',
  EMAIL_TEXT: 'You can also ',
  EMAIL_LINK: 'email us.',
  DATE_FORMAT: 'MM/DD/YYYY',
  DISABILITY_BASICS:[
    {
      uid:'supplemental-disability', 
      title:'What is supplemental disability insurance or IDI?',
      text:'Individual disability income (IDI) insurance can replace a portion of your income if you become too sick or injured to work.  It is individually-owned, so you can take it with you should you change employers or careers.<br/><br/>Supplemental IDI can work with Group LTD coverage provided by your employer to protect more of your unprotected income.'
    },
    {
      uid:'odds-of-disability',
      title:'What are the odds a disability will really happen?',
      text:'<b>1 in 4</b> will become disabled before they retire <i>(U.S. Social Security Administration Fact Sheet, June 2022)</i>.'
    }
  ],
  COVERAGE_INFO:[
    {
      uid:'insurance-carrier', 
      title:'Who is the insurance carrier behind this offer?', 
      text:'Berkshire Life Insurance Company of America (Berkshire Life), a wholly owned stock subsidiary of and administrator for Guardian, is a leading provider of individual disability income insurance.  It is one of the largest non-cancellable individual disability income insurance providers in the United States.<br/><br/>Major independent rating agencies have affirmed Berkshire\'s financial strength & stability.  It currently has a Comdex of 100 out of 100, which is a composite of certain ratings a company has received.<br/><br/>Ratings or rankings are as of 9/12/22 and are subject to change without notice.  Comdex is a composite of certain major ratings (minimum of two ratings) that a company has received.  The Comdex percentile ranks the companies on a scale of 1 to 100 (with "1" being the weakest and "100" the strongest.)'
    },
    {
      uid:'benifit-discount', 
      title:'Is this coverage discounted?', 
      text:'Employees receive a permanent discount for the life of their policy. IDI obtained outside of the worksite is generally not discounted. '
    },
    {
      uid:'coverage-offer', 
      title:'Is coverage offered to all employees?', 
      text:'Eligibility is based on each employee\'s personal income situation; not all employees may be eligible.  This is why all communications during enrollment are confidential and personalized to each eligible employee.'
    },
    {
      uid:'increase-in-salary', 
      title:'What if my salary increases? Can I increase my coverage in the future?', 
      text:'The Automatic Benefit Increase Endorsement (ABIE) is built into your policy to help keep your benefit growing along with your income. These increases are automatic. There may also be future enrollments, which may allow for coverage increases.<br/><br/>If an automatic increase is available, our Company will notify you in writing at least 45 days prior to the date the automatic increase takes effect. Additional premium will be charged for this automatic increase to your policy.'
    },
    {
      uid:'existing-coverage', 
      title:'I have existing coverage in force. Am I still eligible?', 
      text:'There are issue and participation limits.  During the application process, assessment of your eligibility will include a review of other in force disability coverage.  You can also contact your representative or <a href=\'mailto:enrollmentsupport@glic.com\' style=\'color:#0D3F5E\'>enrollmentsupport@glic.com</a> to discuss further.'
    },
    {
      uid:'disable-premium', 
      title:'If I become disabled, will I have to continue paying premiums?', 
      text:'No. If you become eligible for benefits, premiums are waived while you remain disabled.  If any premiums were paid during the Elimination Period, they will be pro-rated and returned to you.'
    }
  ],
  GETTING_POLICY:[
    {
      uid:'only-oppurtunity', 
      title:'Is this my only opportunity to apply?', 
      text:'It is possible there will be re-enrollment opportunities in the future, however, it’s common that pre-existing limitations and policy restrictions may apply. If you are considering coverage at all, you may want to purchase a minimum policy and then increase coverage if the opportunity allows.'
    },
    {
      uid:'paper-application', 
      title:'What if I would prefer a paper application?', 
      text:'You can request a PDF version of a paper application online after logging in, or contact Enrollment Support at <a href=\'mailto:enrollmentsupport@glic.com\' style=\'color:#0D3F5E;\' >enrollmentsupport@glic.com</a>.'
    },
    {
      uid:'policies-delivered', 
      title:'How are policies delivered?', 
      text:'Policies will be delivered electronically via your work email address and should be available within 24 hours. Click <a href=\'https://glic.wistia.com/medias/1or0wm0zza\' style=\'color:#0D3F5E; text-decoration:underline\'>here</a> to learn more.'
    }
  ],
  CONTACT_INFO:[
    {
      uid:'contact-information', 
      title:'Who can I contact with questions about benefits, billing or claims?', 
      text:'Anything pertaining to your policy should be referred to our award-winning <i>Claims Service and Solutions Group</i> by calling (888) 275-7473 or emailing <a href=\'mailto:diclaims@glic.com\' style=\'text-decoration:underline; color:#0D3F5E;\' >diclaims@glic.com</a>. (<i>DALBAR\'s Insurance Service Award, 2019</i>)'
    }
  ],
  FAQ_ROUTE: 'mlde/faq',
  DISCLAIMER:
    'Individual disability income products underwritten and issued by Berkshire Life Insurance Company of America (BLICOA), Pittsfield, MA or provided by Guardian. BLICOA is a wholly owned stock subsidiary of and administrator for The Guardian Life Insurance Company of America (Guardian), New York, NY. Product provisions and availability may vary by state.<br/><br/> Guardian<sup>®</sup> is a registered trademark of The Guardian Life Insurance Company of America.<br/><br/>© ‎2021‎ ‎The Guardian Life Insurance Company of America<br/> 2021-117388 (Exp. 4/23)',
  RECOMMEND_TEXT:
    'We recommend  you download a copy of your completed application form.',
  DEPARTURE_TEXT:
    'Enrollment is complete. We’re reviewing your application and will be in touch shortly to finalize your policy.',
  SECURITY_CODE_NOT_FOUND: 'SecurityCodeNotFound',
  INVALID_SECURITY_CODE: 'Invalid security code. Please try again.',
  SECURITY_CODE_EXPIRED: 'SecurityCodeExpired',
  SECURITY_CODE_EXPIRED_MSG:'Security code has expired.',
  INCORRECT_SECURITY_CODE_MSG_1: 'Incorrect security code.',
  INCORRECT_SECURITY_CODE_MSG_2: 'Incorrect security code. Please try again.',
  APPLICANT_FOUND: 'ApplicantFound',
  APPLICANT_PREVIOUSLY_REGISTERED: 'ApplicantPreviouslyRegistered',
  APPLICANT_NOT_FOUND_MSG: 'Applicant not found.',
  SENT_EMAIL_MSG: 'We have sent you an Email. Please check your inbox.',
  FORGOT_UERID_MODAL_TITLE: 'UserId Recovery Email Sent',
  FORGOT_PASSWORD_MODAL_TITLE: 'Password Recovery Email Sent',
  DISCLAIMER_ONE:'Individual disability income products underwritten and issued by Berkshire Life Insurance Company of America (BLICOA), Pittsfield, MA or provided by Guardian. BLICOA is a wholly owned stock subsidiary of and administrator for The Guardian Life Insurance Company of America (Guardian), New York, NY. Product provisions and availability may vary by state. Optional riders are available for an additional premium. Some policy benefits and features are not available to all occupations.',
  DISCLAIMER_TWO: 'Guardian® is a registered trademark of The Guardian Life Insurance Company of America.',
  INVALID_PHONE_MSG: 'Please enter valid phone number',
  DISCLAIMER_TEXT: '© 2022, The Guardian Life Insurance Company of America, New York, NY. All rights reserved. <br> 2022-144265 (Exp. 10/24)',
  INVALID_USER_ID:'Sorry, this ID already exists; please choose another.',
};

export default appConstants;
